import { gql } from '@apollo/client';

export const GET_SHOWCASE_PROJECTS = gql`
  query GetShowcaseProjects(
    $field: ShowcaseProjectOrderField
    $direction: OrderDirection
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    viewer {
      id
      company {
        id
        showcase {
          id
          publicIdentifier
          showcaseProjects(
            first: $first
            last: $last
            after: $after
            before: $before
            orderBy: { field: $field, direction: $direction }
          ) {
            edges {
              node {
                id
                title
                createdAt
                visible
                __typename
                featuredImage {
                  assetPreviewThumbnail
                }
                project {
                  id
                  formattedLine1
                  databaseId
                  coordinates
                }
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
          }
        }
      }
    }
  }
`;
